import { useMemo } from 'react';
import type { BaseLadder } from 'services/assist-api/entities/ladder-data/ladder-datas';
import { getActiveDataForStartDate } from './start-date.helpers';

export default function useLaddersForStartDate(
  allLadders: BaseLadder[] | undefined,
  startDate: string | undefined
): BaseLadder[] {
  return useMemo(
    () => (startDate ? getActiveDataForStartDate(allLadders || [], startDate) : []),
    [allLadders, startDate]
  ) as BaseLadder[];
}
